import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginRedirect';
import { ThemeProvider } from './theme/ThemeProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          {/* Default route - Landing page (public marketing) */}
          <Route path="/" element={<LandingPage />} />
          
          {/* Direct login page - users can bookmark this */}
          <Route path="/login" element={<LoginPage />} />
          
          {/* Main app route - requires authentication */}
          <Route path="/app/*" element={<App />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);
